import React, { useEffect, useState, useCallback, useMemo } from 'react'

import Autocomplete from 'components/common/Autocomplete'
import useConfiguration from 'hooks/useConfiguration'
import { MODULE_NAMES } from 'utils/constants'

function MetadataAutocomplete({
  value,
  selectedOption,
  setSelectedOption,
  moduleName = MODULE_NAMES.CORRESPONDENCE,
  ...props
}) {
  const [searchValue, setSearchValue] = useState('')
  const { getFieldDefinitions } = useConfiguration()

  const options = useMemo(() => {
    return Object.values(getFieldDefinitions(moduleName))
  }, [getFieldDefinitions, moduleName])

  const getOptionLabel = useCallback((option) => {
    return option?.display || ''
  }, [])

  const handleAutocompleteFilter = useCallback(
    (options) => {
      const filtered = options.filter((option) => {
        return (
          option?.display?.toLowerCase().includes(searchValue.toLowerCase()) ||
          option.field?.toLowerCase().includes(searchValue.toLowerCase()) ||
          option.path?.toLowerCase().includes(searchValue.toLowerCase())
        )
      })
      return filtered
    },
    [searchValue]
  )

  useEffect(() => {
    if (value && selectedOption?.path !== value) {
      const foundOption = options.find(
        (option) => option.path.toLowerCase() === value.toLowerCase()
      )

      if (foundOption) {
        setSelectedOption(foundOption)
        setSearchValue(foundOption.display || '')
      }
    } else if (selectedOption) {
      setSearchValue(selectedOption.display || '')
    } else {
      setSearchValue('')
    }
  }, [value, selectedOption])

  return (
    <Autocomplete
      options={options}
      getOptionLabel={getOptionLabel}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
      selectedOption={selectedOption}
      setSelectedOption={setSelectedOption}
      handleFilter={handleAutocompleteFilter}
      {...props}
    />
  )
}

export default MetadataAutocomplete
